import { useState, useEffect } from "react";

const useDebounce = (value, delay, immediate = false) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (immediate) {
      setDebouncedValue(value);
      return undefined;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, immediate]);

  return debouncedValue;
};

export default useDebounce;
